import { createContext, useContext, useEffect, useState } from "react";
import { api, unwrap } from "@/lib/api";

const BranchContext = createContext(null);

export function BranchProvider({ children }) {
  const [branches, setBranches] = useState([]);
  const [activeBranchId, setActiveBranchId] = useState(() => localStorage.getItem("gloss.branch") || "branch-001");

  useEffect(() => {
    api.get("/branches").then((r) => {
      const list = unwrap(r) || [];
      setBranches(list);
      if (list.length && !list.find((b) => b.id === activeBranchId)) {
        setActiveBranchId(list[0].id);
      }
    }).catch(() => {});
  }, []);

  const selectBranch = (id) => {
    setActiveBranchId(id);
    localStorage.setItem("gloss.branch", id);
  };

  const activeBranch = branches.find((b) => b.id === activeBranchId) || null;

  return (
    <BranchContext.Provider value={{ branches, activeBranchId, activeBranch, selectBranch }}>
      {children}
    </BranchContext.Provider>
  );
}

export const useBranch = () => useContext(BranchContext);
